import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import SecurityCheck from '../SecurityCheck';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <SecurityCheck>
      <div className="flex flex-col min-h-screen bg-gray-50 text-gray-800">
        <Header />
        <main className="flex-grow w-full">{children}</main>
        <WhatsAppButton />
        <Footer />
      </div>
    </SecurityCheck>
  );
};

export default Layout;